import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const twinsSoloParenting: BlogMetaData = {
  title: '双子のワンオペ育児がつらい…同時授乳・お風呂を乗り切るコツ【モンテッソーリ流】',
  description:
    '双子のワンオペ育児はなぜここまで大変なのか、同時に泣く・授乳・お風呂・寝かしつけの場面別対処法、それぞれの個性を大事にする関わり方、モンテッソーリ流で一人時間を作る工夫、相談先までやさしく解説します。',
  thumbnailUrl: '/img/blog-twins-solo-parenting.webp',
  filePath: buildBlogFilePath('twins-solo-parenting'),
  category: BLOG_CATEGORY.PARENTING,
};
